/*jshint esversion: 6 */

const $ = require('jquery');

const $window = $(window);
const hiddenClass = 'page-header__logo--hidden';

// Ab dieser Scroll-Position darf das Logo ueberhaupt ausgeblendet werden.
const hideOffset = 20;
// So viele Pixel muss am Stueck nach oben gescrollt werden, bis es wieder erscheint.
const showThreshold = 50;

let $logo = $();
let lastScroll = 0;
let scrolledUp = 0;
let ticking = false;

function setHidden(hidden) {
  $logo.toggleClass(hiddenClass, hidden);
}

function update() {
  ticking = false;

  // Negative Werte kommen vom Overscroll auf iOS.
  let scroll = Math.max($window.scrollTop(), 0);
  let delta = scroll - lastScroll;
  lastScroll = scroll;

  if (scroll <= 0) {
    scrolledUp = 0;
    setHidden(false);
    return;
  }

  if (delta > 0) {
    scrolledUp = 0;
    if (scroll > hideOffset) {
      setHidden(true);
    }
    return;
  }

  if (delta < 0) {
    scrolledUp -= delta;
    if (scrolledUp >= showThreshold) {
      scrolledUp = 0;
      setHidden(false);
    }
  }
}

function onScroll() {
  if (ticking) {
    return;
  }
  ticking = true;
  window.requestAnimationFrame(update);
}

module.exports = function() {
  $logo = $('.page-header__logo');

  if (!$logo.length) {
    return;
  }

  lastScroll = Math.max($window.scrollTop(), 0);
  scrolledUp = 0;

  $window.off('scroll', onScroll).on('scroll', onScroll);
  update();
};
